/* eslint-disable react/no-array-index-key */
/* eslint-disable sort-keys */
import React from 'react'

import { Content } from '../../components/Typography'
import { SectionContainer } from '../../layouts'
import {
  contentContainer,
  fontColor,
  giftInfoContainer,
  giftItem,
  giftItemsContainer,
  giftTitle,
  infoTitle,
  sectionColor,
} from './MothersGiftInfo.module.css'

const MothersGiftInfo = () => {
  const mainTitle = 'The Gift of Beauty, On Her Terms'

  const introText =
    'The gift card can be used in full or as a discount toward a more comprehensive treatment.'
  const supportText = `
<p>Whether she wants to indulge in a relaxing treatment or put it toward a transformative procedure, our gift cards offer complete flexibility and freedom.</p>
<p>✨ Choose from:</p>
<ul>
  <li>• Pay €40 → Receive €50</li>
  <li>• Pay €50 → Receive €75</li>
  <li>• Pay €150 → Receive €200</li>
</ul>
Let her decide how she wants to glow.
Here are just a few ways she can use it:
`
  const treatments = [
    {
      title: 'Morpheus8 Treatment',
      description: 'skin tightening & collagen boost',
    },
    {
      title: 'Profhilo',
      description: 'deep hydration & skin glow',
    },
    {
      title: 'Lip / Tear Trough Fillers',
      description: 'soft, natural enhancements',
    },
    {
      title: 'Skin Boosters & Growth Factors',
      description: 'for long-term radiance',
    },
    {
      title: 'Thread Lifting',
      description: 'non-surgical lift',
    },
    {
      title: 'Eyelid Correction',
      description: 'starting from €1,200',
    },
    {
      title: 'Face Slimming Injectables',
      description: 'from €270',
    },
    {
      title: 'Liquid Facelift',
      description: 'full facial refresh',
    },
  ]

  const conclusionText =
    'Whether she chooses a luxurious facial or something more advanced, this gift meets her exactly where she is.'

  return (
    <SectionContainer
      extraClassName={sectionColor}
      extraContentClassName={contentContainer}
    >
      <div className={giftInfoContainer}>
        <h2 className={infoTitle}>💝 {mainTitle}</h2>
        <p>{introText}</p>
        <Content extraClassName={fontColor} renderContent={supportText} />
        <div className={giftItemsContainer}>
          {treatments.map((treatment, index) => (
            <div key={index} className={giftItem}>
              <h3 className={giftTitle}>{treatment.title}</h3>
              <p>{treatment.description}</p>
            </div>
          ))}
        </div>

        <p>{conclusionText}</p>
      </div>
    </SectionContainer>
  )
}

export default MothersGiftInfo
